import ImgMessage from './ImgMessage';

export default ImgMessage;